import { Skeleton, SkeletonBox } from '@utilitywarehouse/hearth-react';

import './styles.scss';

const DetailsSkeleton = () => (
  <Skeleton loadingTitle="Energy details loading">
    <SkeletonBox
      className="energy__Details-skeletonWrapper"
      borderRadius="lg"
    />
  </Skeleton>
);

export { DetailsSkeleton };
